import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.mjs";

// ใช้ worker กลางที่ public/pdf.worker.min.js (ร่วมกับ PdfStampEditor) เวอร์ชันต้องตรงกับ pdfjs-dist ใน package.json
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

export default pdfjsLib;
